<script lang="ts">
  import Input from "@kontextwerk/web-sdk/ui/forms/Input.svelte"
  import TableFormCell from "@kontextwerk/web-sdk/ui/layout/TableFormCell.svelte"
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"

  let props: InboxWorkflowCellProps = $props()

  const value = $derived(
    typeof props.binding.value === "string" || typeof props.binding.value === "number"
      ? String(props.binding.value)
      : "",
  )

  const readValue = (event: Event): string => {
    const detail = (event as CustomEvent<{ value?: unknown }>).detail

    if (typeof detail?.value === "string" || typeof detail?.value === "number")
      return String(detail.value)

    return (event.target as HTMLInputElement | null)?.value ?? ""
  }
</script>

<TableFormCell>
  <Input
    type={props.columnConfig.inputType ?? "text"}
    placeholder={props.columnConfig.placeholder ?? props.column.label}
    labelVisibility="hidden"
    {value}
    brightBackground={true}
    surfaceTone="light"
    classList="inbox-table-control"
    disabled={props.binding.disabled}
    onInput={(event) => props.binding.setValue(readValue(event))}
    onChange={(event) => props.binding.setValue(readValue(event))}
  />
</TableFormCell>
